import {createEvent} from "effector";
import {createGate} from "effector-react";

export const ViewProjectGate = createGate()

export const resetProjectDataEv = createEvent()
